import { render, staticRenderFns } from "./message-abstract-image.vue?vue&type=template&id=61e6c880&scoped=true"
import script from "./message-abstract-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-image.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-image.vue?vue&type=style&index=0&id=61e6c880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6c880",
  null
  
)

export default component.exports